import {
  NotificationIcon,
  MenuIcon,
  SearchIcon,
  UserIcon,
  LogOutIcon,
} from '@nimbus-ds/icons'
import { Button, Input, Text, Icon, Popover, Divider } from '@nimbus-ds/components'
import { StoreSwitcher } from './StoreSwitcher'
import { useAuth } from '@/hooks/useAuth'

interface HeaderProps {
  onMenuClick?: () => void
}

export function Header({ onMenuClick }: HeaderProps = {}) {
  const { user, logout } = useAuth()
  return (
    <header className="flex h-16 items-center justify-between gap-2 border-b bg-background px-3 sm:px-6">
      {/* Left: hamburger + store switcher + search */}
      <div className="flex flex-1 items-center gap-2 sm:gap-6 min-w-0">
        {onMenuClick && (
          <button
            type="button"
            onClick={onMenuClick}
            aria-label="Abrir menu"
            className="-ml-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground lg:hidden"
          >
            <MenuIcon size={20} />
          </button>
        )}

        {/* Store switcher (hidden on small screens) */}
        <div className="hidden items-center gap-2 md:flex">
          <StoreSwitcher />
        </div>

        {/* Search — hidden on xs, visible from sm up */}
        <div className="hidden max-w-md flex-1 sm:block">
          <Input
            placeholder="Buscar experimentos, métricas..."
            append={<Icon source={<SearchIcon />} color="neutral-textLow" />}
            appendPosition="start"
          />
        </div>
      </div>

      {/* Actions */}
      <div className="flex shrink-0 items-center space-x-1 sm:space-x-2">
        <div className="sm:hidden">
          <Button appearance="transparent" aria-label="Buscar">
            <Icon source={<SearchIcon />} color="currentColor" />
          </Button>
        </div>
        <Button appearance="transparent" aria-label="Notificaciones">
          <Icon source={<NotificationIcon />} color="currentColor" />
        </Button>

        {/* User menu */}
        <Popover
          arrow={false}
          enabledClick
          content={
            <div className="flex w-56 flex-col gap-1">
              <div className="flex flex-col gap-0.5 px-2 py-1.5">
                <Text fontWeight="medium" color="neutral-textHigh">
                  {user?.store_name || 'User'}
                </Text>
                <Text fontSize="caption">
                  Store ID: {user?.store_id || 'N/A'}
                </Text>
              </div>
              <Divider />
              <button
                type="button"
                onClick={logout}
                className="flex items-center gap-2 rounded px-2 py-1.5 text-sm text-red-600 hover:bg-muted"
              >
                <LogOutIcon size={16} />
                <span>Log out</span>
              </button>
            </div>
          }
        >
          <Button appearance="transparent" aria-label="Cuenta">
            <Icon source={<UserIcon />} color="currentColor" />
          </Button>
        </Popover>
      </div>
    </header>
  )
}
